import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileuploadService {

  baseUrl = environment.apiUrl;

 constructor(private http: HttpClient) {}

 UploadFile(id: any, formData: any) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
  }
    const uploadReq = new HttpRequest('POST', this.baseUrl + `sdsFile/UploadFile/` + id, formData, {
      headers: httpHeaders,
      reportProgress: true,
    });
    this.http.request(uploadReq).subscribe(event => {
      if (event.type === HttpEventType.Response) {
        console.log(event.body);
      }
    });
  }

  DownloadFile(id: any) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/pdf');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/pdf');
    }
    return this.http.get(this.baseUrl + 'sdsFile/DownloadFile/' + id, {headers: httpHeaders});
  }
}